import { Settings } from '@mui/icons-material';
import { SVGICON } from '../../constant/theme';

export const MenuList = [
  //Dashboard
  {
    title: 'Dashboard',
    iconStyle: SVGICON.HomeIcon2,
    classsChange: 'menu-title',
    extraclass: 'first',
    eventKey: 'dashboard',
    menuKey: 'Dashboard',
    to: 'dashboard',
  },
  //Forms
  {
    title: 'Forms',
    classsChange: 'mm-collapse',
    iconStyle: SVGICON.HomeIcon,
    eventKey: 'forms',
    menuKey: 'Forms',
    to: 'forms',
    content: [
      {
        title: 'JHA Form',
        to: 'jha-form',
        eventKey: 'jha-form',
      },
      {
        title: 'Voucher Form',
        to: 'voucher-form',
        eventKey: 'voucher-form',
      },
      {
        title: 'Trip Report Form',
        to: 'tripreport-form',
        eventKey: 'tripreport-form',
      },
      {
        title: 'Nomination for Award Form',
        to: 'award-form',
        eventKey: 'award-form',
      },
      {
        title: 'Application for Educational Assistance Form',
        to: 'aea-form',
        eventKey: 'aea-form',
      },
      {
        title: 'Application for Training',
        to: 'training-form',
        eventKey: 'training-form',
      },
      {
        title: 'Conflict of Interest Form',
        to: 'coi-form',
        eventKey: 'coi-form',
      },
      {
        title: 'Requisition Request Form',
        to: 'requisition-form',
        eventKey: 'requisition-form',
      },
      {
        title: 'Skills Form',
        to: 'skills-form',
        eventKey: 'skills-form',
      },
      {
        title: 'Offer Form',
        to: 'offer-form',
        eventKey: 'offer-form',
      },
      {
        title: 'MCFT Form',
        to: 'mcft-form',
        eventKey: 'mcft-form',
      },
      {
        title: 'EWW Form',
        to: 'eww-form',
        eventKey: 'eww-form',
      },
      {
        title: 'Subcontractor Health and Safety Form',
        to: 'shs-form',
        eventKey: 'shs-form',
      },
      {
        title: 'Facilities Services Request Form',
        to: 'fsr-form',
        eventKey: 'fsr-form',
      },
    ],
  },
  //COI Report
  {
    title: 'COI Report',
    iconStyle: SVGICON.FormIcon,
    eventKey: 'coi-report',
    menuKey: 'COI Report',
    to: 'coi-report',
  },
  {
    title: 'Skills Dashboard',
    classsChange: 'menu-title',
    iconStyle: SVGICON.SkillIcon,
    eventKey: 'skills-dashboard',
    menuKey: 'SkillsDashboard',
    to: 'skills-dashboard',
  },
  //Settings
  {
    name: 'doubleArray',
    title: 'Settings',
    iconStyle: SVGICON.SettingIcon,
    eventKey: 'settings',
    menuKey: 'Settings',
    to: '/settings',
    mainArray: [
      {
        title: 'JHA Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'jha-job-settings',
        content: [
          {
            title: 'JHA Job List',
            to: 'settings/jha-setting',
          },
        ],
      },
      {
        title: 'Project Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'project-code-settings',
        content: [
          {
            title: 'Project Code List',
            to: 'settings/project-code',
          },
        ],
      },
      {
        title: 'Account Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'account-code-settings',
        content: [
          {
            title: 'Account Code List',
            to: 'settings/account-code',
          },
        ],
      },
      {
        title: 'Roles Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'roles-settings',
        content: [
          {
            title: 'Roles List',
            to: 'settings/roles',
          },
        ],
      },
      {
        title: 'MTR Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'mtr-settings',
        content: [
          {
            title: 'Modue To Role List',
            to: 'settings/mtr',
          },
        ],
      },
      {
        title: 'FBR Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'fbr-settings',
        content: [
          {
            title: 'Facility Building Room List',
            to: 'settings/fbr',
          },
        ],
      },
      {
        title: 'Box Folder Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'box-folders-settings',
        content: [
          {
            title: 'Box folderId List',
            to: 'settings/box-folders',
          },
        ],
      },
      {
        title: 'MTE Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'mte-settings',
        content: [
          {
            title: 'MTE List',
            to: 'settings/mte',
          },
        ],
      },
      {
        title: 'User Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'user-settings',
        content: [
          {
            title: 'User List',
            to: 'settings/users',
          },
        ],
      },
      {
        title: 'Task Number Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'task-number-settings',
        content: [
          {
            title: 'Task Number List',
            to: 'settings/task-number',
          },
        ],
      },
      {
        title: 'Award Type Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'award-type-settings',
        content: [
          {
            title: 'Award Type List',
            to: 'settings/awardtypes',
          },
        ],
      },
      {
        title: 'Award Ceremony Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'award-ceremony-settings',
        content: [
          {
            title: 'Award Ceremony List',
            to: 'settings/awardceremonies',
          },
        ],
      },
      {
        title: 'Award History Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'award-history-settings',
        content: [
          {
            title: 'Award History List',
            to: 'settings/awardhistory',
          },
        ],
      },
      {
        title: 'Training History Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'training-history-settings',
        content: [
          {
            title: 'Training History List',
            to: 'settings/traininghistory',
          },
        ],
      },
      {
        title: 'Tuition Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'tuition-settings',
        content: [
          {
            title: 'Tuition History List',
            to: 'settings/tuition',
          },
        ],
      },
      {
        title: 'Course Type Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'course-type-settings',
        content: [
          {
            title: 'Course Type List',
            to: 'settings/coursetype',
          },
        ],
      },
      {
        title: 'Skills Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'skills-settings',
        content: [
          {
            title: 'Skills List',
            to: 'settings/skills',
          },
        ],
      },
      {
        title: 'Skill Category Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'skill-category-settings',
        content: [
          {
            title: 'Skill Category List',
            to: 'settings/skillcategory',
          },
        ],
      },
      {
        title: 'Skill Expertise Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'skill-expertise-settings',
        content: [
          {
            title: 'Skill Expertise List',
            to: 'settings/expertise',
          },
        ],
      },
      {
        title: 'Job Title Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'jobtitle-settings',
        content: [
          {
            title: 'Job Title List',
            to: 'settings/jobtitle',
          },
        ],
      },
      {
        title: 'Job Type Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'jobtype-settings',
        content: [
          {
            title: 'Job Type List',
            to: 'settings/jobtype',
          },
        ],
      },
      {
        title: 'Subcontractor Settings',
        metisMenu: 'has-menu',
        hasMenu: true,
        eventKey: 'subcontractor-settings',
        content: [
          {
            title: 'Subcontractor List',
            to: 'settings/subcontractor',
          },
        ],
      },
    ],
  },
];
